import type {
  LifestyleExposureFrequency,
  LifestyleExposureType,
} from "@louise/medical-history/basic-info/types";

export const EXPOSURE_OPTIONS: {
  id: LifestyleExposureType;
  labelKey: string;
}[] = [
  {
    id: "chemicals",
    labelKey: "med_history.lifestyle.exposure.exposure_type.chemicals",
  },
  {
    id: "x_rays",
    labelKey: "med_history.lifestyle.exposure.exposure_type.x_rays",
  },
  {
    id: "agricultural_area",
    labelKey: "med_history.lifestyle.exposure.exposure_type.agricultural_area",
  },
  {
    id: "nuclear",
    labelKey: "med_history.lifestyle.exposure.exposure_type.nuclear",
  },
  {
    id: "toxins",
    labelKey: "med_history.lifestyle.exposure.exposure_type.toxins",
  },
  {
    id: "prolonged_heat",
    labelKey: "med_history.lifestyle.exposure.exposure_type.prolonged_heat",
  },
  {
    id: "other_exposure",
    labelKey: "med_history.lifestyle.exposure.exposure_type.other_exposure",
  },
];

export const EXPOSURE_FREQUENCY_OPTIONS: {
  id: LifestyleExposureFrequency;
  labelKey: string;
}[] = [
  {
    id: "less_1_a_year",
    labelKey: "med_history.lifestyle.exposure.exposure_frequency.less_1_a_year",
  },
  {
    id: "less_1_a_month",
    labelKey:
      "med_history.lifestyle.exposure.exposure_frequency.less_1_a_month",
  },
  {
    id: "1_a_month",
    labelKey: "med_history.lifestyle.exposure.exposure_frequency.1_a_month",
  },
  {
    id: "2-3_a_month",
    labelKey: "med_history.lifestyle.exposure.exposure_frequency.2-3_a_month",
  },
  {
    id: "1_a_week",
    labelKey: "med_history.lifestyle.exposure.exposure_frequency.1_a_week",
  },
  {
    id: "2-3_a_week",
    labelKey: "med_history.lifestyle.exposure.exposure_frequency.2-3_a_week",
  },
  {
    id: "4-6_a_week",
    labelKey: "med_history.lifestyle.exposure.exposure_frequency.4-6_a_week",
  },
  {
    id: "everyday",
    labelKey: "med_history.lifestyle.exposure.exposure_frequency.everyday",
  },
];
